/**
 *   Created by ATopcu in 2019
 */
import scope from "./scope";
import { exchange } from "@ls/js-fetch";
import SelectionState from "state/selections/SelectionState";
import SummaryType from "state/selections/Constants/SummaryType";
import { selectBaseGroupingParams } from "state/selections/selector";
import { selectDefinitions } from "./selectors";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_DATA = `${scope}/REQUEST_DATA`;
export const RECEIVE_DATA = `${scope}/RECEIVE_DATA`;
export const requestPerfReturnData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
    const [baseParams] = selectBaseGroupingParams(state);

    const absEprTypes = new Set(),
      absEprNetGross = new Set();
    const relEprTypes = new Set(),
      relEprNetGross = new Set();

    definitions.forEach((def) => {
      const eprType = def.type.slice(13); //GS expects "TOTAL_RETURN" part to be sliced off
      if (def.summary === SummaryType.ABSOLUTE) {
        absEprTypes.add(eprType);
        absEprNetGross.add(def.netGross);
      } else {
        relEprTypes.add(eprType);
        relEprNetGross.add(def.netGross);
      }
    });

    const makePerfReturnRequest = async (summary, eprNetGross, eprTypes) => {
      dispatch({ type: REQUEST_DATA, payload: { summary } });
      const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

      dispatch({
        type: RECEIVE_DATA,
        payload: {
          summary,
          data: (
            await exchange({
              params: {
                ...baseParams,
                summary,
                epr_net_gross: eprNetGross,
                epr_types: eprTypes,
                analytics: "NONE",
                results: "ENTITY_PERF_RETURNS",
              },
              url,
              cancelId: `perfReturn-data-${summary}`,
            })
          )?.data,
        },
      });
    };

    if (absEprTypes.size > 0) {
      makePerfReturnRequest(
        SummaryType.ABSOLUTE,
        [...absEprNetGross],
        [...absEprTypes]
      ).then();
    }
    if (relEprTypes.size > 0) {
      makePerfReturnRequest(
        SummaryType.RELATIVE,
        [...relEprNetGross],
        [...relEprTypes]
      ).then();
    }
  };
};
